export const MARKETING_SALES = 'marketing-sales';
export const IGS_NURTURING = 'igs-nurturing';